import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";

export default function ProjectDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/projects/${slug}`).then(({ data }) => setP(data)).catch(() => setErr(true));
  }, [slug]);

  if (err) {
    return (
      <div className="pt-40 pb-32 wrap text-center">
        <div className="label mb-3">— 404 · Project</div>
        <h1 className="font-display uppercase text-5xl md:text-7xl">Not found</h1>
        <p className="mt-4 text-chrome-300">The project you&apos;re looking for isn&apos;t published yet.</p>
        <Link to="/gallery" className="btn mt-8">Back to gallery</Link>
      </div>
    );
  }
  if (!p) {
    return <div className="pt-40 wrap label">Loading…</div>;
  }
  return (
    <>
      <SEO title={`${p.seo_title || p.title} — ProForm`} description={p.seo_description || p.summary} />
      <article className="pt-32 md:pt-40 pb-24">
        <div className="wrap grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="clip-frame aspect-[4/3]">
              {p.featured_image && <img src={p.featured_image} alt={p.title} />}
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="label mb-3">— {p.category}</div>
            <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.95]">{p.title}</h1>
            <div className="mt-6 grid grid-cols-2 gap-4 label">
              <div>Year<div className="text-chrome-100 mt-1">{p.vehicle_year || "—"}</div></div>
              <div>Chassis<div className="text-chrome-100 mt-1">{p.chassis_code || "—"}</div></div>
              <div>Make<div className="text-chrome-100 mt-1">{p.make || "—"}</div></div>
              <div>Model<div className="text-chrome-100 mt-1">{p.model || "—"}</div></div>
              <div>Paint<div className="text-chrome-100 mt-1">{p.paint_manufacturer || "—"}</div></div>
              <div>Color<div className="text-chrome-100 mt-1">{p.paint_color || "—"}</div></div>
            </div>
            <p className="mt-8 text-chrome-300 leading-relaxed">{p.summary}</p>
          </div>
        </div>
        {p.story && (
          <div className="wrap mt-16 max-w-3xl">
            <div className="label mb-3">— Story</div>
            <p className="text-chrome-100 text-lg leading-relaxed whitespace-pre-line">{p.story}</p>
          </div>
        )}
        {(p.before_images?.length || p.during_images?.length || p.after_images?.length) ? (
          <div className="wrap mt-16 grid grid-cols-2 md:grid-cols-3 gap-4">
            {[...(p.before_images||[]), ...(p.during_images||[]), ...(p.after_images||[])].map((src, i) => (
              <div key={i} className="clip-frame aspect-[4/3]"><img src={src} alt={`${p.title} ${i+1}`} /></div>
            ))}
          </div>
        ) : null}
      </article>
    </>
  );
}
